export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-information-line"></i>
            平台介绍
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-6">
            关于黑料网下载
          </h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              <strong>黑料网下载</strong>创立于2024年，是一家专注于<strong>黑料视频在线播放</strong>的综合内容平台。我们致力于为全网用户提供最新、最全、最热的<strong>黑料网在线观看</strong>服务，涵盖娱乐圈八卦、社会热点揭秘、网红动态追踪等多个垂直领域。
            </p>
            <p>
              平台每日由专业编辑团队筛选整理海量内容资源，确保每一条<strong>黑料在线观看</strong>内容都经过严格核实。我们坚持"无需下载、即点即看"的服务理念，让用户在任何设备上都能畅享流畅的<strong>黑料在线看片</strong>体验。
            </p>
            <p>
              目前平台已积累超过10万条视频资源，日均服务超过5万名用户。从<strong>黑料网在线播放</strong>到<strong>黑料视频在线观看</strong>，黑料网下载始终走在内容传播的最前沿，为吃瓜群众提供最及时的资讯服务。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
            <div className="p-5 rounded-xl bg-background-100 border border-secondary-200/60">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-3 mx-auto">
                <i className="ri-shield-check-line text-2xl text-primary-500"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-800 mb-1">内容可靠</h3>
              <p className="text-xs text-foreground-500">专业团队筛选，确保信息真实</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-secondary-200/60">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-3 mx-auto">
                <i className="ri-flashlight-line text-2xl text-accent-500"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-800 mb-1">更新最快</h3>
              <p className="text-xs text-foreground-500">7x24小时不间断追踪热点</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-secondary-200/60">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 mb-3 mx-auto">
                <i className="ri-device-line text-2xl text-secondary-500"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-800 mb-1">多端适配</h3>
              <p className="text-xs text-foreground-500">手机电脑随心切换观看</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}